'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'

const tabLabels: Record<string, string> = {
  prediction: 'Prediction',
  exchanges: 'Exchanges',
  history: 'History',
  news: 'News',
  converter: 'Converter',
}

export function CoinBreadcrumbs({ slug, coinName }: { slug: string; coinName: string }) {
  const pathname = usePathname()
  const segments = pathname.split('/').filter(Boolean)
  const subPage = segments.length > 2 ? segments[2] : null

  return (
    <nav className="flex items-center gap-2 text-xs text-zinc-400 mb-8" style={{ fontFamily: "var(--font-saira), 'Saira', sans-serif" }}>
      <Link href="/" className="hover:text-white transition-colors">Crypto Street</Link>
      <span className="text-zinc-600">/</span>
      <Link href="/prices" className="hover:text-white transition-colors">Prices</Link>
      <span className="text-zinc-600">/</span>
      {subPage ? (
        <>
          <Link href={`/prices/${slug}`} className="hover:text-white transition-colors">{coinName}</Link>
          <span className="text-zinc-600">/</span>
          <span className="text-zinc-400">{tabLabels[subPage] || subPage}</span>
        </>
      ) : (
        <span className="text-zinc-400">{coinName}</span>
      )}
    </nav>
  )
}